import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './presentation/components/Layout/Layout';
import { LandingPage } from './presentation/pages/LandingPage/LandingPage';
import { SobrePage } from './presentation/pages/SobrePage/SobrePage';
import { AulasPage } from './presentation/pages/AulasPage/AulasPage';
import { VisitasPage } from './presentation/pages/VisitasPage/VisitasPage';
import { CalendarioPage } from './presentation/pages/CalendarioPage/CalendarioPage';
import { LojaPage } from './presentation/pages/LojaPage/LojaPage';
import { PodcastPage } from './presentation/pages/PodcastPage/PodcastPage';
import { ContatoPage } from './presentation/pages/ContatoPage/ContatoPage';

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/sobre" element={<SobrePage />} />
          <Route path="/aulas" element={<AulasPage />} />
          <Route path="/visitas" element={<VisitasPage />} />
          <Route path="/calendario" element={<CalendarioPage />} />
          <Route path="/loja" element={<LojaPage />} />
          <Route path="/podcast" element={<PodcastPage />} />
          <Route path="/contato" element={<ContatoPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
